import type { CounterOrderLine } from './api';

/** "Brake pad × 2, Engine oil × 0.5" — what a hand-over will take off the shelf. */
export function summariseLines(lines: Pick<CounterOrderLine, 'skuName' | 'qty'>[]): string {
  return lines.map((l) => `${l.skuName} × ${l.qty.includes('.') ? l.qty.replace(/\.?0+$/, '') : l.qty}`).join(', ');
}
